import { CampaignAccessController } from './campaign-access.controller'

function campaignAccess () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-access/campaign-access.html?$$REVISION$$',
    controller: CampaignAccessController
  }
}

export { campaignAccess }
